import { createContext } from '@chakra-ui/react-utils';

interface IEpisodeContext {
  selectedEpisodeId: string | null;
  setSelectedEpisodeId: (episode: string | null) => void;
}

const [EpisodeContextProvider, useEpisodeContext] = createContext<IEpisodeContext>({
  name: 'EpisodeContext',
  errorMessage:
    'useEpisodeContext: `context` is undefined. Seems you forgot to wrap components in `<EpisodeContextProvider />`',
});

export { EpisodeContextProvider, useEpisodeContext };
